<template>
    <div class="modal-overlay" v-if="visible" @click.self="$emit('close')">
        <div class="modal">
            <div class="modal-header">
                <h1 class="modal-title">{{ group ? 'Edytuj grupę' : 'Dodaj grupę' }}</h1>
                <button class="close-button" @click="$emit('close')">
                    <font-awesome-icon icon="xmark" />
                </button>
            </div>

            <div class="modal-content">
                <form @submit.prevent="handleSubmit">
                    <div class="form-group">
                        <label for="name">Nazwa grupy *</label>
                        <input id="name" v-model="form.name" type="text" required />
                    </div>

                    <div class="form-group">
                        <label for="material">Materiał *</label>
                        <input id="material" v-model="form.material" type="text" required />
                    </div>

                    <div class="form-group">
                        <label for="description">Opis</label>
                        <textarea id="description" v-model="form.description" rows="12" />
                    </div>

                    <div class="modal-actions">
                        <button type="submit" class="save-button" :disabled="trailerStore.loading">
                            {{ trailerStore.loading ? 'Zapisywanie...' : group ? 'Zapisz zmiany' : 'Dodaj grupę' }}
                        </button>
                        <button type="button" class="cancel-button" @click="$emit('close')">Anuluj</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { useTrailerStore } from '@/stores/trailerStore'
import { showErrorToast } from '@/utils/errorUtils'

export default {
    props: {
        visible: Boolean,
        group: Object
    },
    data() {
        return {
            trailerStore: useTrailerStore(),
            form: {
                name: '',
                material: '',
                description: ''
            }
        }
    },
    watch: {
        group: {
            immediate: true,
            handler(group) {
                if (group) {
                    this.form = {
                        name: group.name,
                        material: group.material,
                        description: group.description || ''
                    }
                } else {
                    this.form = {
                        name: '',
                        material: '',
                        description: ''
                    }
                }
            }
        }
    },
    methods: {
        async handleSubmit() {
            this.trailerStore.loading = true
            try {
                if (this.group) {
                    await this.trailerStore.updateTrailerGroup(this.group.id, { ...this.form })
                } else {
                    await this.trailerStore.createTrailerGroup({ ...this.form })
                }
                this.$emit('saved')
                this.$emit('close')
            } catch (err) {
                showErrorToast(err, 'Błąd przy zapisie grupy.')
            } finally {
                this.trailerStore.loading = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 20px;
}

.modal {
    width: 100%;
    max-width: 600px;
    background-color: $color-background;
    border-radius: 12px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.modal-header {
    padding: 16px 20px;
    background-color: $color-primary;
    color: $color-white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
}

.close-button {
    background: none;
    border: none;
    color: $color-white;
    font-size: 1.3rem;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.modal-content {
    padding: 20px;

    form {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 5px;

        label {
            font-weight: 500;
            font-size: 1rem;
        }

        input,
        textarea {
            font-family: 'Inter', sans-serif;
            padding: 10px;
            border: 2px solid $color-grey;
            border-radius: 8px;
            font-size: 1rem;
            transition: border 0.3s ease;

            &:focus {
                border-color: $color-primary;
                outline: none;
            }
        }

        textarea {
            resize: vertical;
        }
    }
}

.modal-actions {
    display: flex;
    gap: 1rem;
    margin-top: 20px;

    button {
        flex: 1;
        padding: 10px 16px;
        border: none;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .save-button {
        background-color: $color-primary;
        color: $color-white;

        &:hover {
            background-color: $color-primary-dark;
        }
    }

    .cancel-button {
        background-color: $color-grey;
        color: $color-text;

        &:hover {
            background-color: $color-grey-dark;
        }
    }
}

@media (max-width: 768px) {
    .modal-actions {
        flex-direction: column;

        button {
            width: 100%;
        }
    }

    .modal-header {
        padding: 12px 16px;
    }

    .modal-title {
        font-size: 1.1rem;
    }
}
</style>
